export function parseImageToMarkdown(blocks) {
  return `!${blocks.file.url}|alt="${blocks.caption}"!\n`;
}
